// SPDX-License-Identifier: FSL-1.1-Apache-2.0
/**
 * @module ConvexComponent
 * @package @geenius/analytics/convex
 * @description Declares the packaged Convex component identifier used when the
 * analytics tables and functions are mounted as a reusable component.
 */

import { defineComponent } from "convex/server";

const component = defineComponent("analytics");
export default component;
